import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {TestsResponse} from '../model/tests/tests.response';

@Injectable({
  providedIn: 'root'
})
export class TestsService {

  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  public getTests(): Observable<TestsResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<TestsResponse>(this.baseUrl.concat('/tests'), { headers });
  }

  public getClientTests(clientId: string): Observable<TestsResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<TestsResponse>(this.baseUrl.concat('/tests/client/' + clientId), { headers });
  }

  public getSelectedClientTests(clientId: number): Observable<TestsResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<TestsResponse>(this.baseUrl.concat('/tests/client/' + clientId + '/project'), { headers });
  }

  public getProjectTests(clientId: number, projectId: number): Observable<TestsResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get<TestsResponse>(this.baseUrl.concat('/tests/client/' + clientId + '/project/' + projectId), { headers });
  }
}
